<script setup lang="ts">
    import { FrontpageItemGroup } from '@/shared/helpers/api';
    import FrontpageItem from './FrontpageItem.vue';

    const props = defineProps<{
        group: FrontpageItemGroup;
    }>();

</script>

<template>
    <div class="pb-6">
        <h2 class="group-title">
            {{ props.group.label }}
        </h2>
        <frontpage-item
            v-for="(item, index) in props.group.items"
            :key="index"
            :item="item"
            :group="props.group" />
    </div>
</template>

<style scoped>
.group-title {
    font-weight: bolder;
    font-size: 110%;
    margin-bottom: 1.2rem;
}
</style>
